function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Capitan reveal v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.Capitan.de/
 *
 * Date: 2018-03-21
 * MIT License (MIT)
 */
import Capitan from '../../code/js/Capitan/Capitan';
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
var _ = {
  defaults: {
    componentSelector: '.reveal',
    settings: {
      viewportFilter: /reveal-(l|h)t-(xs|sm|md|lg|xl|xxl|hd|mhd|uhd)/g
    },
    selectors: {
      content: '.reveal__content',
      trigger: '.reveal__trigger',
      triggerText: '.reveal__trigger-text',
      group: '.reveal--group'
    },
    classes: {
      initiallyOpend: 'reveal-initialy-opened',
      hidden: 'is-hidden',
      active: 'is-active'
    },
    callbacks: {},
    errorMessages: {}
  }
};
var o = _.defaults;

var setViewportReveal = function setViewportReveal(element) {
  var elementClasses = element.classList.value || element.classList[0];

  if (elementClasses.match(o.settings.viewportFilter)) {
    var content = element.querySelector(o.selectors.content);
    var viewportReveal = o.settings.viewportFilter.exec(elementClasses);
    var viewportResult = viewportReveal[0].split('-');
    var viewPortRange = viewportResult[1];
    var viewPortSize = viewportResult[2];
    var breakpoint = [viewportResult[1], viewportResult[2]];

    if (Capitan.assertBreakpoint(viewPortRange, viewPortSize)) {
      initReveal(element);
    } else {
      content.setAttribute('style', "");
      content.classList.remove(o.classes.hidden);
      content.classList.add(o.classes.active);
    }
  } else {
    initReveal(element);
  }
};

var initReveal = function initReveal(element) {
  var content = element.querySelector(o.selectors.content);
  var trigger = element.querySelector(o.selectors.trigger);
  content.classList.remove(o.classes.hidden);
  content.classList.add(o.classes.active);
  setHeight(content);
  content.classList.add(o.classes.hidden);
  content.classList.remove(o.classes.active);

  if (!element.classList.contains('js-init')) {
    trigger.addEventListener('click', function () {
      toggleReveal(content, trigger);
    });
    content.addEventListener('transitionend', function (event) {
      if (event.target === content && !event.target.classList.contains(o.classes.hidden)) {
        event.target.setAttribute('style', "height: auto;");
        setHeight(event.target);
      }
    });
  }

  element.classList.add('js-init');
  /** call toggleReveal to open element initially. in reveal--group only one element can be opened */

  element.classList.contains(o.classes.initiallyOpend) && toggleReveal(content, trigger);
}; // const scrollTopNavMobile = (element) => {
//   const parentElementIsNavMobileItem = element.parentElement.classList.contains('level-top')
//   const nav = document.querySelector('.nav-mobile__flyout');
//   if (parentElementIsNavMobileItem && nav) { nav.scrollTo({ top: 0, behavior: 'smooth' }); }
//   else { return }
// }
// const scrollTopMobile = (element) => {
//   const parentElementIsNavMobileItem = element.parentElement.classList.contains('level-top')
//   if (parentElementIsNavMobileItem) { return }
//   if (Capitan.assertBreakpoint('lt', 'lg')) {
//     element.parentElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" });
//   }
// }


var toggleReveal = function toggleReveal(content, trigger) {
  var isGroup = content.closest(o.selectors.group);
  var sameClass = content.classList.contains(o.classes.hidden);

  if (isGroup && sameClass) {
    isGroup.querySelectorAll(o.selectors.content).forEach(function (element) {
      element.classList.add(o.classes.hidden);
      element.closest(o.componentSelector).querySelector(o.selectors.trigger).classList.remove(o.classes.active);
    });
  }

  if (trigger.dataset.open) {
    var triggerInner = trigger.querySelector('.reveal__trigger-text');
    var savedText = triggerInner.innerText;
    triggerInner.innerText = trigger.dataset.open;
    trigger.dataset.open = savedText;
  }

  content.classList.toggle(o.classes.hidden);
  trigger.classList.toggle(o.classes.active); // Ensure the reveal trigger is visible and directly where the anchor nav ends

  var anchorNavHeight = document.querySelector('.anchor-nav');

  if (Capitan.assertBreakpoint('lt', 'lg')) {
    typeof window !== "undefined" && window.scrollTo({
      top: trigger.getBoundingClientRect().top + window.scrollY - "".concat(anchorNavHeight ? 180 : 80),
      behavior: 'smooth'
    });
  }
}; // Helper Functions


var setHeight = function setHeight(element) {
  element.setAttribute('style', "height: ".concat(element.scrollHeight > element.offsetHeight ? element.scrollHeight : element.offsetHeight, "px;"));
};

export function init() {
  console.log('reveal init');
  var elements = Array.from(document.querySelectorAll(o.componentSelector));
  CapSmartResize(function () {
    !Capitan.Vars.isNativeMobile && elements.forEach(function (el) {
      return setViewportReveal(el);
    });
  });
  elements.forEach(function (el) {
    return setViewportReveal(el);
  });
}
export function refreshAccordeonSize() {
  var elements = document.querySelectorAll("".concat(o.componentSelector, " ").concat(o.selectors.content));

  _toConsumableArray(elements).forEach(function (element) {
    setHeight(element);
  });
}